/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useState } from 'react';
import { Link } from "react-router-dom";
import { slide as BMenu } from 'react-burger-menu';
import { AuthContext } from '../../context/auth-context';
import { CoreContext } from '../../context/core-context';
import {
    HouseDoor,
    BoxArrowRight,
    Gear,
    PersonCircle,
    People,
    PersonPlus,
    Images as ImagesIcon,
    Sliders as SlidersIcon,
    Book,
    JournalText,
    CalendarEvent,
    ChatQuote,
    PersonBadge,
    FileEarmarkText,
    Youtube,
    Building,
    Globe2,
    Grid,
    Mortarboard,
    CalendarCheck,
    Stars,
    ListTask,
    ShieldCheck
} from 'react-bootstrap-icons';

const Menu = () => {
    const authContext = useContext(AuthContext);
    const coreContext = useContext(CoreContext);

    const [isOpen, setIsOpen] = useState(false);

    const handleStateChange = (state) => {
        setIsOpen(state.isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    const clientName = coreContext.client?.item_name || 'Website Builder';
    const isSuperAdmin = authContext.item?.categoryId === 1;
    const isReseller = authContext.item?.categoryId === 1 || authContext.item?.categoryId === 2;

    return (
        <>
            {/* Slide Drawer Sidebar */}
            <BMenu isOpen={isOpen} onStateChange={handleStateChange}>
                <div className="sidebar-profile-header">
                    <div className="brand-section" style={{ marginBottom: '8px' }}>
                        <div className="brand-icon-wrapper" style={{ width: '32px', height: '32px', fontSize: '16px' }}>
                            <Globe2 />
                        </div>
                        <div>
                            <h4 className="sidebar-brand-name">{clientName}</h4>
                            <span className="sidebar-brand-sub">Website Management</span>
                        </div>
                    </div>
                </div>

                <div className="menu-header">Main</div>
                <Link onClick={closeMenu} className="menu-item" to="/">
                    <HouseDoor /> <span>Home</span>
                </Link>
                <Link onClick={closeMenu} className="menu-item" to="/self">
                    <PersonCircle /> <span>My Profile</span>
                </Link>
                <Link onClick={closeMenu} className="menu-item" to="/settings">
                    <Gear /> <span>Settings</span>
                </Link>

                {isSuperAdmin && (
                    <>
                        <div className="menu-header">Super Admin</div>
                        <Link onClick={closeMenu} className="menu-item" to="/features">
                            <ShieldCheck /> <span>Features</span>
                        </Link>
                        <Link onClick={closeMenu} className="menu-item" to="/categories">
                            <Grid /> <span>Categories</span>
                        </Link>
                        <Link onClick={closeMenu} className="menu-item" to="/roles">
                            <ShieldCheck /> <span>Roles</span>
                        </Link>
                        <Link onClick={closeMenu} className="menu-item" to="/districts">
                            <Globe2 /> <span>Districts</span>
                        </Link>
                        <Link onClick={closeMenu} className="menu-item" to="/states">
                            <Globe2 /> <span>States</span>
                        </Link>
                        <Link onClick={closeMenu} className="menu-item" to="/countries">
                            <Globe2 /> <span>Countries</span>
                        </Link>
                    </>
                )}

                <div className="menu-header">Administration</div>
                <Link onClick={closeMenu} className="menu-item" to="/menus">
                    <ListTask /> <span>Menus</span>
                </Link>
                <Link onClick={closeMenu} className="menu-item" to="/users">
                    <People /> <span>Users</span>
                </Link>
                <Link onClick={closeMenu} className="menu-item" to="/add-user">
                    <PersonPlus /> <span>Add User</span>
                </Link>

                <div className="menu-header">Front Page Content</div>
                <Link onClick={closeMenu} className="menu-item" to='/sliders'>
                    <SlidersIcon /> <span>Slider</span>
                </Link>
                <Link onClick={closeMenu} className="menu-item" to="/educational-solutions">
                    <Mortarboard /> <span>Educational Solutions</span>
                </Link>
                <Link onClick={closeMenu} className="menu-item" to="/enroll-today">
                    <CalendarCheck /> <span>Enroll Today</span>
                </Link>
                <Link onClick={closeMenu} className="menu-item" to="/register-now">
                    <CalendarCheck /> <span>Register Now</span>
                </Link>
                <Link onClick={closeMenu} className="menu-item" to="/teachers">
                    <PersonBadge /> <span>Teachers</span>
                </Link>
                <Link onClick={closeMenu} className="menu-item" to="/testimonials">
                    <ChatQuote /> <span>Testimonials</span>
                </Link>
                <Link onClick={closeMenu} className="menu-item" to="/events">
                    <CalendarEvent /> <span>Events</span>
                </Link>
                <Link onClick={closeMenu} className="menu-item" to="/generals">
                    <Grid /> <span>General Items</span>
                </Link>
                <Link onClick={closeMenu} className="menu-item" to="/blogs">
                    <JournalText /> <span>Latest News / Blogs</span>
                </Link>
                <Link onClick={closeMenu} className="menu-item" to="/courses">
                    <Book /> <span>Courses</span>
                </Link>
                <Link onClick={closeMenu} className="menu-item" to="/fun-facts">
                    <Stars /> <span>Fun Facts</span>
                </Link>

                {isReseller && (
                    <>
                        <div className="menu-header">Reseller</div>
                        <Link onClick={closeMenu} className="menu-item" to="/clients">
                            <Building /> <span>Clients</span>
                        </Link>
                        <Link onClick={closeMenu} className="menu-item" to="/sign-up">
                            <PersonPlus /> <span>Add Client</span>
                        </Link>
                    </>
                )}

                <div className="menu-header">Media & Pages</div>
                <Link onClick={closeMenu} className="menu-item" to="/pages">
                    <FileEarmarkText /> <span>Pages</span>
                </Link>
                <Link onClick={closeMenu} className="menu-item" to="/images">
                    <ImagesIcon /> <span>Images / Docs</span>
                </Link>
                <Link onClick={closeMenu} className="menu-item" to="/videos">
                    <Youtube /> <span>YouTube Videos</span>
                </Link>

                <div className="menu-header" style={{ marginTop: '20px' }}>Session</div>
                <Link onClick={closeMenu} className="menu-item" to="/logout" style={{ color: '#f87171' }}>
                    <BoxArrowRight /> <span>Sign Out</span>
                </Link>
            </BMenu>

            {/* Elegant Top Header Navigation Bar */}
            <header className="app-top-header">
                <div className="brand-section">
                    <div className="brand-icon-wrapper">
                        <Globe2 />
                    </div>
                    <div>
                        <h1 className="brand-name-title">{clientName}</h1>
                    </div>
                    <span className="brand-live-badge">Live Portal</span>
                </div>

                <div className="header-quick-links">
                    <Link to="/images" className="header-nav-btn">
                        <ImagesIcon /> <span>Media Library</span>
                    </Link>
                    <Link to="/pages" className="header-nav-btn">
                        <FileEarmarkText /> <span>Pages</span>
                    </Link>
                    <Link to="/self" className="header-nav-btn">
                        <PersonCircle /> <span>Profile</span>
                    </Link>
                    <Link to="/logout" className="header-logout-btn" title="Sign Out">
                        <BoxArrowRight /> <span>Sign Out</span>
                    </Link>
                </div>
            </header>
        </>
    );
};

export default Menu;
